/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Roster_EmptyInputs */

const th_roster_empty = /** @type {(inputs: Roster_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยังไม่มีผู้เล่นในทีมนี้`)
};

const en_roster_empty = /** @type {(inputs: Roster_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No players on this roster yet.`)
};

const ja_roster_empty = /** @type {(inputs: Roster_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このロースターにはまだ選手がいません。`)
};

const zh_roster_empty = /** @type {(inputs: Roster_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此阵容中还没有球员。`)
};

const es_roster_empty = /** @type {(inputs: Roster_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no hay jugadores en esta plantilla.`)
};

const pt_roster_empty = /** @type {(inputs: Roster_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum jogador neste elenco ainda.`)
};

const id_roster_empty = /** @type {(inputs: Roster_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada pemain di skuad ini.`)
};

const fr_roster_empty = /** @type {(inputs: Roster_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun joueur dans cet effectif pour l’instant.`)
};

const tl_roster_empty = /** @type {(inputs: Roster_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wala pang manlalaro sa squad na ito.`)
};

const vi_roster_empty = /** @type {(inputs: Roster_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có cầu thủ nào trong đội hình này.`)
};

const ko_roster_empty = /** @type {(inputs: Roster_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 선수단에 아직 선수가 없습니다.`)
};

const de_roster_empty = /** @type {(inputs: Roster_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Spieler in diesem Kader.`)
};

const ru_roster_empty = /** @type {(inputs: Roster_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В этом составе пока нет игроков.`)
};

const tr_roster_empty = /** @type {(inputs: Roster_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu kadroda henüz oyuncu yok.`)
};

const it_roster_empty = /** @type {(inputs: Roster_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancora nessun giocatore in questa rosa.`)
};

const pl_roster_empty = /** @type {(inputs: Roster_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`W tym składzie nie ma jeszcze zawodników.`)
};

const uk_roster_empty = /** @type {(inputs: Roster_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`У цьому складі поки немає гравців.`)
};

const hi_roster_empty = /** @type {(inputs: Roster_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस टीम में अभी कोई खिलाड़ी नहीं है।`)
};

const ar_roster_empty = /** @type {(inputs: Roster_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا يوجد لاعبون في هذه التشكيلة بعد.`)
};

const ms_roster_empty = /** @type {(inputs: Roster_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada pemain dalam skuad ini.`)
};

const bn_roster_empty = /** @type {(inputs: Roster_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এই দলে এখনও কোনও খেলোয়াড় নেই।`)
};

const zh_tw2_roster_empty = /** @type {(inputs: Roster_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這份名單中還沒有球員。`)
};

const zh_hk2_roster_empty = /** @type {(inputs: Roster_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這份名單中還沒有球員。`)
};

const ur_roster_empty = /** @type {(inputs: Roster_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اس اسکواڈ میں ابھی کوئی کھلاڑی نہیں۔`)
};

const fa_roster_empty = /** @type {(inputs: Roster_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هنوز بازیکنی در این فهرست تیم نیست.`)
};

const sw_roster_empty = /** @type {(inputs: Roster_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakuna wachezaji kwenye kikosi hiki bado.`)
};

const nl_roster_empty = /** @type {(inputs: Roster_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen spelers in deze selectie.`)
};

/**
* | output |
* | --- |
* | "No players on this roster yet." |
*
* @param {Roster_EmptyInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const roster_empty = /** @type {((inputs?: Roster_EmptyInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Roster_EmptyInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_roster_empty(inputs)
	if (locale === "ja") return ja_roster_empty(inputs)
	if (locale === "zh") return zh_roster_empty(inputs)
	if (locale === "es") return es_roster_empty(inputs)
	if (locale === "pt") return pt_roster_empty(inputs)
	if (locale === "id") return id_roster_empty(inputs)
	if (locale === "fr") return fr_roster_empty(inputs)
	if (locale === "tl") return tl_roster_empty(inputs)
	if (locale === "vi") return vi_roster_empty(inputs)
	if (locale === "ko") return ko_roster_empty(inputs)
	if (locale === "de") return de_roster_empty(inputs)
	if (locale === "ru") return ru_roster_empty(inputs)
	if (locale === "tr") return tr_roster_empty(inputs)
	if (locale === "it") return it_roster_empty(inputs)
	if (locale === "pl") return pl_roster_empty(inputs)
	if (locale === "uk") return uk_roster_empty(inputs)
	if (locale === "hi") return hi_roster_empty(inputs)
	if (locale === "ar") return ar_roster_empty(inputs)
	if (locale === "ms") return ms_roster_empty(inputs)
	if (locale === "bn") return bn_roster_empty(inputs)
	if (locale === "zh-TW") return zh_tw2_roster_empty(inputs)
	if (locale === "zh-HK") return zh_hk2_roster_empty(inputs)
	if (locale === "ur") return ur_roster_empty(inputs)
	if (locale === "fa") return fa_roster_empty(inputs)
	if (locale === "sw") return sw_roster_empty(inputs)
	if (locale === "nl") return nl_roster_empty(inputs)
	return en_roster_empty(inputs)
});